export default {"src":"/_next/static/media/paw.68f27fa6.svg","height":52,"width":52,"blurWidth":0,"blurHeight":0};